import { AiOutlineEdit } from 'react-icons/ai';
import { Link } from 'react-router-dom';
import type { OwnerType } from '../../../../common/constants';

interface IProps {
  ownerEntityType: OwnerType;
  ownerEntityId: string;
}

const NoDataContainer: React.FC<IProps> = ({ ownerEntityType, ownerEntityId }) => {
  const DEFAULT_RULE_NOT_EXIST_MSG = `No default rule exists for this ${ownerEntityType}.`;
  const ADD_DEFAULT_RULE_BUTTON_LABEL = 'Add Default Rule';

  return (
    <div className="h-full w-full justify-center items-center flex flex-col">
      <span className="text-lg">{DEFAULT_RULE_NOT_EXIST_MSG}</span>
      <Link to={`/admin/rules/${ownerEntityType}/${ownerEntityId}`}>
        <div className="flex py-2 text-gray-50 px-2 bg-[#1D8A43] text-center rounded-lg space-between  justify-center items-center">
          <AiOutlineEdit size={20} />
          <button className="text-sm px-2">{ADD_DEFAULT_RULE_BUTTON_LABEL}</button>
        </div>
      </Link>
    </div>
  );
};

export default NoDataContainer;
